import type { ChipDefinition } from '@/types/hid8051';

/**
 * Sonix SN8F5708 — 8051 Flash family, SWAT interface, 8 KB ROM
 */
export const SN8F5708: ChipDefinition = {
  name: 'SN8F5708',
  family: 'sonix-8051',
  deviceId: 0x00005708,       // Placeholder — confirm with hardware
  flashSize: 8 * 1024,        // 8 KB ROM
  pageSize: 64,               // 64 byte erase pages (estimated)
  configSize: 0,              // Config bytes TBD
};
